import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { CARD_NAME_MAX_LENGTH } from 'const/limits'
import {
  CardModalView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import CreateTemplateAction from 'components/CardActions/Template'

export class CreateTemplate extends React.Component {
  static propTypes = {
    cardId: PropTypes.number.isRequired,

    intl: PropTypes.object.isRequired,
    leftSidebar: PropTypes.object.isRequired,

    name: PropTypes.string.isRequired,
    requestAddCardTemplate: PropTypes.func.isRequired
  }

  handleValidate = ({ name }) => {
    const { intl } = this.props

    const errors = {}
    if (name && name.length > CARD_NAME_MAX_LENGTH) {
      errors.name = intl.formatMessage({ id: 'CARD_NAME_TOO_LONG' }, { limit: CARD_NAME_MAX_LENGTH })
    }
    return errors
  }

  handleSubmit = ({ name }) => {
    const { cardId, requestAddCardTemplate } = this.props

    if (name) {
      requestAddCardTemplate({
        cardId,
        name
      })

      this.props.leftSidebar.close()
    }
  }

  render () {
    const {
      name
    } = this.props

    return (
      <CardModalView
        title={<FormattedMessage id='CARD_TEMPLATE_HEADER' />}
      >
        <ViewBody>
          <CreateTemplateAction
            validate={this.handleValidate}
            onSubmit={this.handleSubmit}
            initialValues={{
              name
            }}
          />
        </ViewBody>
      </CardModalView>
    )
  }
}

export default injectIntl(withLeftSidebar(CreateTemplate))
